import styled from "styled-components"
import themeSettings from "../../styles/theme"

const Hero = styled.div`
  position: relative;
  width: 100vw;
  max-width: 100%;
  height: calc(100vh - ${themeSettings.navHeight}px);
  margin-top: ${themeSettings.navHeight}px;
  background-color: #eee;

  display: flex;
  align-items: center;
  justify-content: center;

  overflow: hidden;

  cursor: none;

  @media screen and (max-width: 1024px) {
    display: none;
  }
`

const HeroTouch = styled.div`
  display: none;
  @media screen and (max-width: 1024px) {
    display: block;
    width: 100vw;
    max-width: 100%;
    height: calc(100vh - ${themeSettings.mobileNavHeight}px);
    margin-top: ${themeSettings.mobileNavHeight}px;
    overflow: hidden;
    /* class "carousel" */
    & > div {
      height: 100%;
      /* class "horizontalSlider" */
      & > div {
        height: 100%;
        max-height: 100%;
        /* class "carousel__slider-tray-wrapper" */
        & > div {
          height: 100%;
          max-height: 100%;
          /* class "sliderTray" */
          & > ul {
            height: 100%;
            max-height: 100%;
            display: flex;
            transition: transform 0.3s ease;
            & > li {
              height: 100%;
              max-height: 100%;
              /* class "slideInner" */
              & > div {
                height: 100%;
              }
            }
          }
        }
      }
    }
  }
`

const MobileArrow = styled.div`
  display: none;
  position: absolute;
  top: 50%;
  right: ${themeSettings.mobileMargins.page};
  width: 29px;
  height: 20px;
  transform: translateY(-50%);
  z-index: 9999;
  @media screen and (max-width: 1024px) {
    display: block;
  }
`

const HeroSlide = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  @media screen and (max-width: 1024px) {
    position: initial;
  }
`

const Image = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  @media screen and (max-width: 1024px) {
    position: initial;
  }
`

const Video = styled.div`
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  max-width: 100%;
  height: 100%;
  padding: 0 ${themeSettings.margins.page};
  background-color: ${themeSettings.colors.light};
  overflow: hidden;
  pointer-events: none;

  @media screen and (max-width: 1024px) {
    position: relative;
    top: initial;
    left: initial;
  }

  @media screen and (max-width: 414px) {
    padding: 0 ${themeSettings.mobileMargins.page};
  }
`

const VideoWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  overflow: hidden;
  width: 100%;
  height: 120%;
  transform: translateY(-50%);

  /* @media screen and (max-width: 1280px) {
    width: 140%;
  } */

  @media screen and (max-width: 1024px) {
    width: 100%;
    height: 100%;
    pointer-events: none;
  }

  iframe {
    /* opacity: 0.5; */
    width: 100vw;
    min-width: 177.77vh; /* Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
    /* height: 56.25vw; Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
    height: 75vw; /* Given a 4:3 aspect ratio, 3/4*100 = 75 */
    min-height: 100vh;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /* width: 100%;
    height: 56.25%;
    min-height: 100%;
    min-width: 177.77%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); */
    /* @media screen and (max-width: 1024px) {
      min-width: 400%;
    } */
  }
`

const Footer = styled.div`
  box-sizing: border-box;
  position: absolute;
  padding: ${themeSettings.margins.page};
  width: 100%;
  bottom: 0;
  z-index: 999;
  pointer-events: none;

  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  & > h2 {
    &:nth-child(2) {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }

`

const Introduction = styled.div`
  box-sizing: border-box;
  width: 100vw;
  max-width: 100%;
  background-color: ${themeSettings.colors.dark};
  color: ${themeSettings.colors.light};
  padding: calc(${themeSettings.margins.large} * 2.8) 16vw;

  text-align: center;

  font-size: calc(${themeSettings.fontSizes.medium} * 1.6);
  font-style: normal;
  letter-spacing: 0.02em;

  @media screen and (max-width: 1440px) {
    font-size: calc(${themeSettings.fontSizes.medium} * 1.2);
  }

  @media screen and (max-width: 1024px) {
    font-size: ${themeSettings.fontSizes.base};
    padding: ${themeSettings.margins.large} ${themeSettings.margins.page};
  }
`

export default {
  Hero,
  HeroTouch,
  MobileArrow,
  Footer,
  HeroSlide,
  Image,
  Video,
  VideoWrapper,
  Introduction
}